export class CounterController {
    constructor(root, params = {}) {
        this._root = root;
        this._params = params;

        this._input = this._root.querySelector("input[type='number']");
        this._incrementCta = this._root.querySelector('[data-increment]');
        this._decrementCta = this._root.querySelector('[data-decrement]');
        this._minCount = this._input.getAttribute('min');
        this._maxCount = this._input.getAttribute('max');

        this._increment = this._increment.bind(this);
        this._decrement = this._decrement.bind(this);
        this._updateDecrementCtaState = this._updateDecrementCtaState.bind(this);
        this._updateIncrementCtaState = this._updateIncrementCtaState.bind(this);
        this._checkCTAStates = this._checkCTAStates.bind(this);
    }

    _checkWrapperValidity() {
        if (!this._input) {
            throw new Error('Counter : given wrapper does not countain any input of type number');
        }
    }

    _getValue() {
        this._count = parseFloat(this._input.value) || 0;
        return parseFloat(this._count);
    }

    _clampCount() {
        if (this._maxCount && this._count > this._maxCount) {
            this._count = this._maxCount;
        }
        if (this._minCount && this._count < this._minCount) {
            this._count = this._minCount;
        }
        return parseFloat(this._count);
    }

    _updateInputValue() {
        this._clampCount();
        this._input.value = this._count;
        this._checkCTAStates();

        const inputEvent = document.createEvent('Event');
        inputEvent.initEvent('input', true, true);

        this._input.dispatchEvent(inputEvent);
    }

    _setInitialState() {
        if (this._input.value) {
            return;
        }

        this._input.value = 0;
        this._updateDecrementCtaState(this._count);
    }

    _increment(e) {
        if (e.shiftKey) {
            this._count += 10;
            this._updateInputValue();
            return;
        }

        if (this._params.stepCount) {
            this._count += parseFloat(this._params.stepCount);
        } else {
            this._count++;
        }
        this._updateInputValue();
    }

    _decrement(e) {
        if (e.shiftKey) {
            this._count -= 10;
            this._count = this._count < 0 ? 0 : this._count;
            this._updateInputValue();
            return;
        }

        if (this._params.stepCount) {
            this._count -= parseFloat(this._params.stepCount);
        } else {
            this._count--;
        }
        this._updateInputValue();
    }

    _checkCTAStates() {
        this._getValue();
        this._updateIncrementCtaState();
        this._updateDecrementCtaState();
    }

    _updateIncrementCtaState() {
        if (this._maxCount) {
            if (parseFloat(this._count) >= parseFloat(this._maxCount)) {
                this._incrementCta.disabled = true;
            } else {
                this._incrementCta.removeAttribute('disabled');
            }
        }
    }

    _updateDecrementCtaState() {
        if (this._minCount) {
            if (parseFloat(this._count) <= parseFloat(this._minCount)) {
                this._decrementCta.disabled = true;
            } else {
                this._decrementCta.removeAttribute('disabled');
            }
        }
    }

    _addListeners() {
        this._incrementCta.addEventListener('click', this._increment);
        this._decrementCta.addEventListener('click', this._decrement);
        this._input.addEventListener('input', this._updateDecrementCtaState);
        this._input.addEventListener('change', this._checkCTAStates);
    }

    _removeListeners() {
        this._incrementCta.removeEventListener('click', this._increment);
        this._decrementCta.removeEventListener('click', this._decrement);
        this._input.removeEventListener('input', this._updateDecrementCtaState);
        this._input.removeEventListener('change', this._checkCTAStates);
    }

    initialize() {
        this._checkWrapperValidity();
        this._getValue();
        this._setInitialState();
        this._addListeners();
    }

    destroy() {
        this._removeListeners();
        this._input.value = 0;
    }
}
